<div class="min-h-screen flex items-center justify-center p-4 bg-[var(--beige)] overflow-hidden relative"
     style="background-image: url('assets/fondo-rugoso.webp'); background-size: auto; background-position: center;">
  
  <!-- Logo en la parte superior -->
  <div class="absolute top-6 left-1/2 transform -translate-x-1/2 w-40">
    <img src="assets/logo.webp" alt="Logo" class="w-full h-auto">
  </div>
  
  <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border-4 border-[var(--black)] bg-[var(--white)] w-full max-w-md relative mt-12">
    <!-- Mascota flotando en la esquina superior derecha del card -->
    <!-- <div class="absolute -top-16 -right-10 w-32 h-32">
      <img src="assets/mascota.webp" alt="Mascota" class="w-full h-auto transform rotate-12 drop-shadow-lg">
    </div> -->
    
    <h2 class="uppercase text-[25px]/[25px] mobile-m:text-[35px]/[35px] text-center font-normal text-[var(--dark-orange)]">
      Selecciona tu país
    </h2>
    
    <div class="w-full border-t border-dotted mb-6 mt-2"></div>
    
    <div class="mt-4 mb-6">
      <label for="countrySelect" class="block text-[16px]/[16px] font-medium text-gray-700 mb-2">
        País:
      </label>
      <select
        id="countrySelect"
        class="w-full px-4 py-2 border-2 border-[var(--black)] rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-[var(--blue)]"
        [(ngModel)]="selectedIso"
      >
        <option [ngValue]="null" disabled selected>Seleccionar país</option>
        <option *ngFor="let country of countries" [value]="country.isoCode">
          {{ country.name }}
        </option>
      </select>
    </div>
    
    
    <!-- <div class="mt-8">
      <button
        class="w-full bg-black text-white px-4 py-2 rounded-xl hover:bg-gray-800 disabled:opacity-50 flex items-center justify-center gap-2"
        [disabled]="!selectedIso"
        (click)="confirmCountry()"
      >
        <span>Confirmar</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    </div> -->


    <div class="mt-8 flex justify-center">
      <app-button [function]="confirmCountry.bind(this)" [text]="'Confirmar'" styleType="primary" [fullWidth]="false"></app-button>
    </div>
  
    
    <!-- Pequeña mascota decorativa inferior -->
    <!-- <div class="flex justify-center mt-4">
      <img src="assets/mascota.webp" alt="Mascota pequeña" class="w-10 h-auto opacity-70">
    </div> -->
  </div>
</div>